import styled from 'styled-components';

export const AuthorPageContainer = styled.div`
	width: 100%;
	padding: 2.5rem 1rem;

	.breadcrumbs {
		margin-bottom: 2rem;
	}

	.container {
		max-width: 1084px;
		width: 100%;
		margin: 0 auto;
	}

	.header {
		margin-bottom: 2rem;

		.image {
			overflow: hidden;
			width: 4rem;
			height: 4rem;
			margin-bottom: 0.5rem;
			border-radius: 50%;

			img {
				width: 100%;
				height: 100%;
				object-fit: cover;
			}
		}

		.title {
			margin-bottom: 0.25rem;
		}
	}

	.card {
		flex: 0 1 calc(33.33% - 2rem);
	}

	.meta {
		color: ${({ theme }) => theme.v3.colors.dark[0]};

		.separator {
			width: 0.25rem;
			height: 0.25rem;
			border-radius: 50%;
			background: ${({ theme }) => theme.v3.colors.gray[9]};
		}
	}
`;
